ko.components.register('acl-group-editor', {
	viewModel: function(opts) {
		var self = this;

		self.loading = ko.observable(false);
		self.messages = ko.observableArray();
		self.showMessages = ko.observable(true);

		self.accessLevels = ko.observableArray(opts.accessLevels);
		self.defaultAccessLevel = ko.observable(opts.defaultAccessLevel);

		self.forTypes = ko.observableArray(opts.forTypes);
		self.forTypesOptions = opts.forTypesOptions || {};
		self.forTypeRoute = ko.observable(opts.forTypeRoute);
		self.helperRules = ko.observableArray(opts.helperRules);
		self.requiredTypes = ko.observableArray(opts.requiredTypes);
		self.forTypeMessages = ko.observableArray(opts.forTypeMessages);

		self.permissions = ko.observableArray();

		self.toggleMessages = function(){
			self.showMessages(!self.showMessages());
		};

		// permisions

		self.loadPermissions = function(callback){
			if(self.loading())
				return;
			self.permissions.removeAll();
			self.loading(true);
			$.ajax({
				type: "post",
				dataType: "json",
				data: $.extend({ 'do': 'list' }, App.csrf||{}),
				complete: function(){
					self.loading(false);
					callback && callback();
				},
				success: function(r){
					if(r && r.ok) {
						for(var i=0;i<r.items.length;i++)
							self.permissions.push(new AclPermission(r.items[i]));
					}
				}
			});
		};

		self.getNonRoutePermissions = function(){
			return self.permissions().filter(function(item){ return item.for_type() !== self.forTypeRoute(); });
		};

		self.getRoutePermissions = function(){
			return self.permissions().filter(function(item){ return item.for_type() === self.forTypeRoute(); });
		};

		self.getRouteOptionIdByName = function(name){
			var o = self.forTypesOptions[self.forTypeRoute()];
			for(var i in o)
			{
				if(o.hasOwnProperty(i) && o[i]['label'] === name)
					return o[i]['id'];
			}
			return false;
		};

		self.getRouteByName = function(name){
			var oId = self.getRouteOptionIdByName(name),
				tmp = self.getRoutePermissions().filter(function(item){ return item.for_id() === oId; });
			if(tmp.length > 0)
				return tmp.pop();
			return false;
		};

		self.addRouteByName = function(name){
			var oId = self.getRouteOptionIdByName(name),
				tmp = self.getRoutePermissions().filter(function(item){ return item.for_id() === oId; });
			if(tmp.length === 0 && oId)
				self.permissions.push(new AclPermission({for_type: self.forTypeRoute(), for_id: oId, access: self.defaultAccessLevel()}));
			return false;
		};

		self.getPermissionsByType = function(type){
			return self.permissions().filter(function(item){ return item.for_type() === type; });
		};

		self.newPermission = function(){
			self.permissions.push(new AclPermission({access: self.defaultAccessLevel()}));
		};

		self.newRoutePermission = function(){
			self.permissions.push(new AclPermission({for_type: self.forTypeRoute(), access: self.defaultAccessLevel()}));
		};

		self.undoPermission = function(item){
			item.undoChanges();
		};

		self.getUnsavedPermissions = function(){
			return self.permissions().filter(function(p){
				return (p.isUpdated() && !p.isEmpty());
			});
		};

		self.savePermissions = function(){
			var tmp = self.getUnsavedPermissions();
			while(tmp.length > 0) {
				var p = tmp.pop();
				self.loading(false);
				self.savePermission(p);
			}
		};

		self.savePermission = function(item){
			if(self.loading())
				return;
			self.loading(true);
			$.ajax({
				type: "post",
				dataType: "json",
				data: $.extend({ 'do': 'add', pid: item.id(), for_type: item.for_type(), for_id: item.for_id(), access: item.access() }, App.csrf||{}),
				complete: function(){
					self.loading(false);
					self.permissionsChange();
				},
				success: function(r){
					if(r && r.ok) {
						item.id(r.item.id);
						item.resetUpdated();
					} else if(r.error)
						alert(r.error);
				}
			});
		};

		self.removePermission = function(item){
			if(parseInt(item.id()) === 0)
			{
				self.permissions.remove(item);
				return;
			}
			if(!confirm('Are you sure?'))
			return;
			if(self.loading())
				return;
			self.loading(true);
			$.ajax({
				type: "post",
				dataType: "json",
				data: $.extend({ 'do': 'remove', pid: item.id() }, App.csrf||{}),
				complete: function(){ self.loading(false); },
				success: function(r){
					if(r && r.ok) {
						self.permissions.remove(item);
					} else if(r.error)
						alert(r.error);
				}
			});
		};

		// type options

		self.hasTypeOptions = function(item){
			return (item && self.forTypesOptions.hasOwnProperty(item.for_type()));
		};

		self.getTypeOptions = function(item){
			var options = [{id: 0, label: '- Any -'}];
			if(!self.hasTypeOptions(item))
				return options;
			var o = self.forTypesOptions[item.for_type()];
			for(var i in o) {
				if(o.hasOwnProperty(i))
					options.push(o[i]);
			}
			return options;
		};

		self.getTypeAccessOptions = function(item){
			var options = [],
				levels = self.accessLevels();
			for(var i in levels)
			{
				if(!levels.hasOwnProperty(i))
					continue;
				var label = levels[i]['label'];
				if(label.indexOf('Full') === -1)
				{
					if(item.for_type() && item.for_type().indexOf('credentials') !== -1)
						options.push(levels[i]);
					else {
						var l = levels[i]['label'];
						if(l.indexOf('restricted') === -1)
							options.push(levels[i]);
					}
				}
			}
			return options;
		};

		// onchange helper

		self.permissionsChange = function() {
			for(var k in self.requiredTypes()) {
				var t = self.requiredTypes()[k];
				if(self.getPermissionsByType(t).length === 0)
					self.permissions.push(new AclPermission({for_type: t, access: self.defaultAccessLevel()}));
			}
			for(var k in self.helperRules()) {
				var r = self.helperRules()[k];
				if(r && self.getPermissionsByType(r['type']).length  > 0)
					self.addRouteByName(r['route']);
			}

			self.messages.removeAll();

			for(var k in self.forTypeMessages())
			{
				var t = self.forTypeMessages()[k];
				if(t['type'])
					if(self.getPermissionsByType(t['type']).length > 0)
						self.messages.push(t['message']);
				if(t['types'])
				{
					for(var i in t['types'])
						if(self.getPermissionsByType(t['types'][i]).length > 0)
						{
							self.messages.push(t['message']);
							break;
						}
				}
			}
		};

		self.loadPermissions(function(){
			self.permissions.subscribe(self.permissionsChange, null, "change");
			self.permissionsChange();
		});
	},
	template: "<div class=\"acl\">\n\t<h3>Group Permissions\n\t\t<button class=\"btn btn-primary float-right\" data-bind=\"visible: getUnsavedPermissions().length > 0, click: savePermissions\">Save All</button>\n\t</h3>\n\t<div class=\"row\">\n\t\t<div class=\"col mb-2\">\n\t\t\t<label class=\"text-muted float-right\" style=\"font-size:75%;\">\n\t\t\t\t<input type=\"checkbox\" data-bind=\"checked: showMessages\" />\n\t\t\t\tShow Hints\n\t\t\t</label><br />\n\t\t\t<div class=\"alert alert-info\" data-bind=\"visible: showMessages() && messages().length > 0\">\n\t\t\t\t<ul data-bind=\"foreach: messages\">\n\t\t\t\t\t<li data-bind=\"html: $data\"></li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t\t<table class=\"table table-striped table-responsive\">\n\t\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Type</th>\n\t\t\t\t\t<th>Value</th>\n\t\t\t\t\t<th>Access</th>\n\t\t\t\t\t<th class=\"w-10\"></th>\n\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody class=\"flex-row\" data-bind=\"foreach: getNonRoutePermissions()\">\n\t\t\t\t<tr data-bind=\"css: {'bg-warning': $component.hasTypeOptions($data) && for_id() == 0}, style: { background: isEmpty() ? 'rgba(255,0,0,.1)' : 'inherit' }\">\n\t\t\t\t\t<td><select data-bind=\"value: for_type, options: $component.forTypes().filter(function(i){ return i.id != 'route';}), optionsValue: 'id', optionsText: 'label', optionsCaption: '- Please Select -'\"></select></td>\n\t\t\t\t\t<td><select data-bind=\"visible: $component.hasTypeOptions($data), value: for_id, options: $component.getTypeOptions($data), optionsValue: 'id', optionsText: 'label'\"></select></td>\n\t\t\t\t\t<td><select data-bind=\"value: access, options: $component.getTypeAccessOptions($data), optionsValue: 'id', optionsText: 'label', optionsCaption: '- Please Select -'\"></select></td>\n\t\t\t\t\t<td class=\"text-nowrap\">\n\t\t\t\t\t\t<button class=\"btn btn-outline-danger btn-sm\" data-bind=\"click: $component.removePermission\"><span class=\"ic ic-remove\"></span></button>\n\t\t\t\t\t\t<span data-bind=\"visible: isUpdated()\">\n\t\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" data-bind=\"visible: !isEmpty(), click: $component.savePermission\">Save</button>\n\t\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" data-bind=\"visible: id() != 0, click: $component.undoPermission\">Undo</button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: newPermission\">Add Permission</button>\n\t\t</div>\n\t\t<div class=\"col\">\n\t\t\t<h4>Routes Access</h4>\n\t\t\t<div class=\"alert alert-warning alert-dismissable show in\" data-bind=\"visible: showMessages() && getRoutePermissions().length > 0\">\n\t\t\t\tSelect <strong>Write</strong> to allow create new items.\n\t\t\t\t<button class=\"close\" data-dismiss=\"alert\">&times;</button>\n\t\t\t</div>\n\t\t\t<table class=\"table table-striped table-responsive\">\n\t\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Route</th>\n\t\t\t\t\t<th>Access</th>\n\t\t\t\t\t<th class=\"w-10\"></th>\n\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody class=\"flex-row\" data-bind=\"foreach: getRoutePermissions()\">\n\t\t\t\t<tr data-bind=\"css: {'bg-warning': $component.hasTypeOptions($data) && for_id() == 0}, style: { background: isEmpty() ? 'rgba(255,0,0,.1)' : 'inherit' }\">\n\t\t\t\t\t<td><select data-bind=\"visible: $component.hasTypeOptions($data), value: for_id, options: $component.getTypeOptions($data), optionsValue: 'id', optionsText: 'label'\"></select></td>\n\t\t\t\t\t<td><select data-bind=\"value: access, options: $component.getTypeAccessOptions($data), optionsValue: 'id', optionsText: 'label', optionsCaption: '- Please Select -'\"></select></td>\n\t\t\t\t\t<td class=\"text-nowrap\">\n\t\t\t\t\t\t<button class=\"btn btn-outline-danger btn-sm\" data-bind=\"click: $component.removePermission\"><span class=\"ic ic-remove\"></span></button>\n\t\t\t\t\t\t<span data-bind=\"visible: isUpdated()\">\n\t\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" data-bind=\"visible: !isEmpty(), click: $component.savePermission\">Save</button>\n\t\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" data-bind=\"visible: id() != 0, click: $component.undoPermission\">Undo</button>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t\t<button class=\"btn btn-primary\" data-bind=\"click: newRoutePermission\">Add Route</button>\n\t\t</div>\n\t</div>\n</div>"
});